import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REVENUE_SUBS_ONE_TIME_CONTRIBUTIONS = createFcmDetails('revenue_subs_one_time_contributions', {
	owner: 'Membership',
	context: 'Membership landing page',
	description: 'This FC is to make one time contributions available on the membership landing page',
	import: false,
});
